import React from 'react';

export default function Correct() {
  return <>{`You were correct! :D`}</>;
}